// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieListItem_root__cDBjz","wrapper":"CookieListItem_wrapper__MWdPw","description":"CookieListItem_description__dNDnr"};